// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"84028244","337":"5c880fa5","455":"9510b1d2","588":"d581b573"}[chunkId] + ".chunk.js";
};